<template>
  <div class="l-contentsBox l-bgGray">
    <div class="l-contentsBox__min-header" :class="{ 'is-check' : roughDiagItem.roughDiagResultItem.answer }">
      <div class="l-contentsBox__min-ttl">
        <h3 style="white-space: pre-line;">{{ roughDiagItem.checkItem }}</h3>
      </div>
      <div class="l-formGroup">
        <RadioButton :options="selectList"
          v-model="roughDiagItem.roughDiagResultItem.answer"
          :selectedValue="this.roughDiagItem.roughDiagResultItem.answer"
          @input="emitChangeAnswer"
        ></RadioButton>
      </div>
    </div>
    <transition name="roughdiag-fade" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
      <div class="l-contentsBox__min-body" v-show="isPresenceProblem || (this.taiouDispType==2 ? this.roughDiagItem.roughDiagResultItem.answer == 2 : this.roughDiagItem.roughDiagResultItem.answer == 1 ) ">
        <p class="l-text" style="white-space: pre-line;">{{ roughDiagItem.remediation }}</p>

        <div class="l-min-reference" v-show="roughDiagItem.guideCode1">
        <h3>参考資料</h3>
        <ul>
            <li v-show="roughDiagItem.guideCode1"><a href="javascript:void(0)" @click="download(roughDiagItem.guideCode1)" class="l-pdf" >参考資料１</a></li>
            <li v-show="roughDiagItem.guideCode2"><a href="javascript:void(0)" @click="download(roughDiagItem.guideCode2)" class="l-pdf" >参考資料２</a></li>
            <li v-show="roughDiagItem.guideCode3"><a href="javascript:void(0)" @click="download(roughDiagItem.guideCode3)" class="l-pdf" >参考資料３</a></li>
        </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import RadioButton from '@/components/parts/form/RadioButton.vue';
import constant from '@/const';
import { saveAs } from "file-saver";

export default {
  components: {
    RadioButton,
  },
  data() {
    return {
      selectList: constant.ROUGH_DIAG_ANSWER_VALUE,
      isPresenceProblem: false,
    }
  },
  props: {
    roughDiagItem: {
      default: {
        checkItem: '',
        roughDiagResultItem: {
          answer: null
        }
      }
    },
    taiouDispType: null
  },
  methods: {
    emitChangeAnswer: function (value) {
      this.isPresenceProblem = (this.taiouDispType==2 ? value == 2 : value == 1 );
      this.$emit("emit-change-answer", value);
    },
    beforeEnter: function(el) {
      el.style.height = '0';
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function(el) {
      el.style.height = '0';
    },
    async download(guideCd) {
      await saveAs('/ld/api/master/guide/downloadByGuideCd?guideCd=' + guideCd);
    },

  }
}
</script>

<style scoped>

.roughdiag-fade-enter-active {
  transition: height .1s ease-in-out;
}
.roughdiag-fade-leave-active {
  transition: height .1s ease-in-out;
}

.roughdiag-fade-enter-to, .roughdiag-fade-leave {
  overflow: hidden;
}
.roughdiag-fade-enter, .roughdiag-fade-leave-to {
  overflow: hidden;
}

</style>
